var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDisconnectCross(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2010_277)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.21 9.79C21.82 9.4 21.19 9.4 20.8 9.79L16.01 14.58L11.22 9.79C10.83 9.4 10.2 9.4 9.81002 9.79C9.42002 10.18 9.42002 10.81 9.81002 11.2L14.6 15.99L9.81002 20.78C9.42002 21.17 9.42002 21.8 9.81002 22.19C10.01 22.39 10.26 22.48 10.52 22.48C10.78 22.48 11.03 22.38 11.23 22.19L16.02 17.4L20.81 22.19C21.01 22.39 21.26 22.48 21.52 22.48C21.78 22.48 22.03 22.38 22.23 22.19C22.62 21.8 22.62 21.17 22.23 20.78L17.44 15.99L22.23 11.2C22.62 10.81 22.62 10.18 22.23 9.79H22.21Z",
    fill: "#F2F2F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2010_277"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisconnectCross);
export default __webpack_public_path__ + "static/media/DisconnectCross.5dc47e0179573a1c606814482561654b.svg";
export { ForwardRef as ReactComponent };